export default __webpack_public_path__ + "static/media/lynnSocialMb.c1dc4451.png";